<p>nearest-temple-card works!</p>
